module.exports = __webpack_public_path__ + "img/bottom-01.88886446.png";